// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/table.js';

import { paths } from '../generated/table';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('table', Original, paths);
